import React from 'react';
import { toJS } from 'mobx';
import { observer } from 'mobx-react';
import PropTypes from 'prop-types';
import { browserHistory } from 'react-router';
import { PartnerStudentVariationListService } from '../../services/CustomerSuccessKpiListService';
import { get } from 'lodash';
import PartnerStudentVariationTable from './PartnerStudentVariationTable';

class PartnerStudentVariationDetailTableContainer extends React.Component {
  static propTypes = {
    type: PropTypes.oneOf(['segment', 'distributor']).isRequired,
    typeId: PropTypes.string.isRequired,
  };

  constructor(props) {
    super(props);
    PartnerStudentVariationListService.load();
  }

  render() {
    return (
      <PartnerStudentVariationTable
        loading={
          PartnerStudentVariationListService.fetchCurrent.fetching ||
          PartnerStudentVariationListService.fetchPrevious.fetching
        }
        values={toJS(PartnerStudentVariationListService.getCompaniesByType(this.props.type, this.props.typeId))}
        feedbackColorRender={PartnerStudentVariationListService.getFeedbackColor}
        onSelect={(row) =>
          browserHistory.push(
            `/kpis/customer-success/${this.props.type}/${get(this.props, 'typeId', 'NA')}/company/${row.id}/details`
          )
        }
        formatter={PartnerStudentVariationListService.getFormattedValue}
      />
    );
  }
}

export default observer(PartnerStudentVariationDetailTableContainer);
